const MIN_ELAPSED_TO_CANCEL = 10 * 60 * 1000; // ms = minutes * seconds_per_minute * milliseconds_per_second

export const STATUS = Object.freeze({
  canceled: 'CANCELED',
  completed: 'COMPLETED_SUCCESSFULLY',
  delayed: 'DELAYED',
  expired: 'EXPIRED',
  failed: 'COMPLETED_WITH_ERRORS',
  inProgress: 'IN_PROGRESS',
  pending: 'PENDING',
  sleeping: 'SLEEPING',
  warnings: 'COMPLETED_WITH_WARNINGS',
});

export const SUCCESS_STATUSES = Object.freeze([
  STATUS.completed,
  STATUS.warnings,
]);

export const INCOMPLETE_STATUSES = Object.freeze([
  STATUS.delayed,
  STATUS.inProgress,
  STATUS.pending,
  STATUS.sleeping,
]);

export const FAILED_STATUSES = Object.freeze([
  STATUS.canceled,
  STATUS.expired,
  STATUS.failed,
]);

export const isSuccessfulJob = (job) => SUCCESS_STATUSES.includes(job?.status);

export const isIncompleteJob = (job) => INCOMPLETE_STATUSES.includes(job?.status);

export const isFailedJob = (job) => FAILED_STATUSES.includes(job?.status);

export const isCanceledJob = (job) => job?.status === STATUS.canceled;

export function isJobCancelable(item) {
  const lastUpdated = new Date(item?.last_updated || 0);
  return (
    isIncompleteJob(item) && new Date() - lastUpdated >= MIN_ELAPSED_TO_CANCEL
  );
}
